import { render, staticRenderFns } from "./propositionList.vue?vue&type=template&id=684c0eca&scoped=true&"
import script from "./propositionList.vue?vue&type=script&lang=js&"
export * from "./propositionList.vue?vue&type=script&lang=js&"
import style0 from "./propositionList.vue?vue&type=style&index=0&id=684c0eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684c0eca",
  null
  
)

export default component.exports